jQuery(".trigger_autoplay").click(function() {
var video = jQuery('.product-slideshow__item video');
video.trigger('play');
});
jQuery("span.custom_widget_subscription_heading_item").click(function() {
jQuery('span.custom_widget_subscription_heading_item').removeClass('active');
jQuery(this).addClass('active');
jQuery('.price_subscription_trigger').removeClass('active');
jQuery(this).addClass('active');
var current_tab = $(this).attr('data_tab');
var selling_plan = $(this).attr('selling_plan');
var variant_id = $(this).attr('variant_id');
jQuery('[name="id"]').val(variant_id);   
if(selling_plan != ""){
jQuery('[name="selling_plan"]').removeAttr('disabled');
jQuery('[name="selling_plan"]').val(selling_plan);   
} else {
jQuery('[name="selling_plan"]').attr('disabled','disabled');
jQuery('[name="selling_plan"]').val(selling_plan);  
}
jQuery(this).parents('.custom_widget_subscription').find('.custom_widget_subscription_content').hide();
jQuery(this).parents('.custom_widget_subscription').find('.custom_widget_subscription_content[data_tab="'+current_tab+'"]').slideDown();
jQuery('.price_subscription_trigger').hide();
jQuery('.price_subscription_trigger[data_tab="'+current_tab+'"]').show();
});


jQuery("span.subscription_heading_member_item").click(function() {
var current_tab = $(this).attr('data_tab');
jQuery('span.subscription_heading_member_item').removeClass('active');
jQuery(this).parents('.custom_widget_subscription').find('.subscription_heading_member_item[data_tab="'+current_tab+'"]').addClass('active');
jQuery(this).parents('.custom_widget_subscription').find('.subscription_heading_member_content').hide();
jQuery(this).parents('.custom_widget_subscription').find('.subscription_heading_member_content[data_tab="'+current_tab+'"]').show();
jQuery('.subscription_prices_item').removeClass('active');
jQuery('.subscription_prices_item[data_tab="'+current_tab+'"]').addClass('active');
jQuery('.subscription_prices_item').hide();
jQuery('.subscription_prices_item[data_tab="'+current_tab+'"]').show();

var selling_plan = $(this).attr('selling_plan');
var variant_id = $(this).attr('variant_id');
jQuery('.custom_widget_subscription_heading_item[data_tab="1"]').attr('variant_id',variant_id);
jQuery('.custom_widget_subscription_heading_item[data_tab="1"]').attr('selling_plan',selling_plan);
jQuery('[name="id"]').val(variant_id);   
jQuery('[name="selling_plan"]').removeAttr('disabled');
jQuery('[name="selling_plan"]').val(selling_plan);  
});


/*

jQuery("span.custom_widget_subscription_heading_item:nth-child(2)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
jQuery('.variants_custom li:nth-child(1) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
setTimeout(function () {
  jQuery('.product__info.product__prices').removeClass('updating');
  window.history.replaceState(null, '', window.location.pathname);
}, 1000);
//jQuery('input[name="quantity"]').val('1');
  
});
jQuery("span.custom_widget_subscription_heading_item:nth-child(1)").click(function() {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
jQuery('.subscription_heading_member_item:nth-child(1').trigger('click');
});

jQuery(".subscription_heading_member_item:nth-child(1)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.variants_custom li:nth-child(1) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
jQuery('.appstle_subscription_radio_wrapper').trigger('click');
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
}, 1000);
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
  jQuery('.product__info.product__prices').removeClass('updating');
}, 1500);
});
jQuery(".subscription_heading_member_item:nth-child(2)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.variants_custom li:nth-child(2) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
jQuery('.appstle_subscription_radio_wrapper').trigger('click');
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
}, 1000);
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
  jQuery('.product__info.product__prices').removeClass('updating');
}, 1500);
});
jQuery(".subscription_heading_member_item:nth-child(3)").click(function() {
  jQuery('.product__info.product__prices').addClass('updating');
jQuery('.variants_custom li:nth-child(3) input').trigger('click');
  $('.product-slideshow__thumbs .product-slideshow__thumb:first-child button').trigger('click');
  $('.product-slideshow__item:first-child video').trigger('play');
jQuery('.appstle_subscription_radio_wrapper').trigger('click');
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(1).trigger('click');
}, 1000);
setTimeout(function () {
jQuery('.appstle_sub_widget input[name=selling_plan]').eq(0).trigger('click');
  jQuery('.product__info.product__prices').removeClass('updating');
}, 1500);
});
*/


$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(document).on("click", ".header__icons.header__icons--right .btn-icon.btn-search", function (e) {
jQuery('sht-header').addClass('header--predictive-search-open');
});

$(document).on("click", ".js-predictive-search-close-trigger", function (e) {
jQuery('sht-header').removeClass('header--predictive-search-open');
});
